import { Component, OnInit, ComponentRef } from '@angular/core';
import { UtilsService } from '../../../services/utils.service';
import {
  IModalDialog,
  IModalDialogOptions,
  IModalDialogButton,
  ModalDialogService,
} from 'ngx-modal-dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../services/api.service';
import {
  LeadSource,
  Onboarding,
  PuntoDiContatto,
  Status,
} from '../../../models/onboarding';

@Component({
  selector: 'alg-exit-popup',
  templateUrl: './alg-exit-popup.component.html',
  styleUrls: ['./alg-exit-popup.component.scss'],
})
export class AlgExitPopupComponent implements OnInit {
  actionButtons: IModalDialogButton[];
  modalService: ModalDialogService;
  public currentOnboarding: Onboarding;
  public hoursList = [
    { label: '09:00 - 10:00', value: '09:00 - 10:00' },
    { label: '10:00 - 11:00', value: '10:00 - 11:00' },
    { label: '11:00 - 12:00', value: '11:00 - 12:00' },
    { label: '15:00 - 16:00', value: '15:00 - 16:00' },
    { label: '16:00 - 17:00', value: '16:00 - 17:00' },
    { label: '17:00 - 18:00', value: '17:00 - 18:00' },
  ];
  public formData = {
    phoneNumber: 0,
    date: '',
    hours: '',
  };
  public showDatePicker: boolean = false;
  public phoneForm = new FormGroup({
    phoneNumberInput: new FormControl(this.formData.phoneNumber, {
      validators: [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(11),
      ],
    }),
    dateInput: new FormControl(this.formData.date, {
      validators: [Validators.required],
    }),
    hoursInput: new FormControl(this.formData.hours, {
      validators: [Validators.required],
    }),
  });
  public requestReceived = false;
  public requestFailed: boolean;
  public tomorrow = new Date();
  public tomorrowDateConverted;
  public isMobile = false;
  public isDesktop = false;
  public isLoading = false;

  constructor(
    private utils: UtilsService,
    private datePipe: DatePipe,
    private api: ApiService
  ) {
    this.actionButtons = [
      {
        text: '',
        buttonClass: 'alg-btn-close',
        onAction: () => {
          this.utils.abilityOverflow();
          return true;
        },
      },
    ];

    this.tomorrow.setDate(this.tomorrow.getDate() + 1);
    this.tomorrowDateConverted = datePipe.transform(
      this.tomorrow.toString(),
      'yyyy-MM-dd'
    );
  }

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct)
      .subscribe(([onboarding, product]) => {
        this.currentOnboarding = onboarding;
        this.currentOnboarding.product = product._id;
      });
  }

  public sendProspectContact() {
    this.formData.hours = this.formData.hours.split(' ')[0];
    const callMeExitPopUp = { ...this.currentOnboarding };
    callMeExitPopUp.firstname = 'N/D';
    callMeExitPopUp.lastname = 'N/D';
    callMeExitPopUp.phone = this.formData.phoneNumber;
    callMeExitPopUp.leadSource = LeadSource.recall;
    callMeExitPopUp.contactAtHour = this.formData.hours
      ? this.formData.hours
      : null;
    callMeExitPopUp.contactAtDay = this.formData.date
      ? this.formData.date
      : null;
    callMeExitPopUp.puntoDiContatto = PuntoDiContatto.exitpopup;
    callMeExitPopUp.webStatus = Status.callme;
    callMeExitPopUp.activationType = null;
    this.isLoading = true;
    this.api
      .createOnboarding(callMeExitPopUp)
      .toPromise()
      .then(() => {
        this.isLoading = false;
        this.requestReceived = true;
        this.actionButtons.push({
          text: 'Chiudi',
          buttonClass: 'button-close',
          onAction: () => {
            this.utils.abilityOverflow();
            return true;
          },
        });
      })
      .catch(() => {
        this.isLoading = false;
        this.requestFailed = !this.requestFailed;
      });
  }

  alwaysAvailable() {
    if (this.phoneForm.controls.phoneNumberInput.status === 'INVALID') {
      this.phoneForm.controls.phoneNumberInput.markAsTouched();
      return;
    } else {
      this.sendProspectContact();
    }
  }

  makeAppointment() {
    if (this.phoneForm.controls.phoneNumberInput.status === 'INVALID') {
      this.phoneForm.controls.phoneNumberInput.markAsTouched();
      return;
    } else {
      this.showDatePicker = true;
      if (this.phoneForm.status === 'VALID') {
        this.sendProspectContact();
      }
    }
  }

  isInvalid(formControl) {
    if (this.phoneForm.controls[formControl].status === 'INVALID') {
      return true;
    } else {
      return false;
    }
  }

  dialogInit(
    reference: ComponentRef<IModalDialog>,
    options: Partial<IModalDialogOptions<any>>
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/alg-exit-popup/alg-exit-popup.component.ts